import { createRoot, Root } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import BreadcrumbsProvider from '../../hooks/useBreadcrumbs/BreadcrumbsProvider';
import { store } from '../../stores/store';
import AppProvider from '../AppProvider';
import Sportsbook from './SportsBook';

const roots: Record<string, Root> = {};

export default function SportsbookRenderer() {
  Array.from(document.querySelectorAll('.bm-sportsbook')).forEach((el) => {
    const id = el.getAttribute('data-id') || 'unknown';

    if (!roots[id]) {
      roots[id] = createRoot(el!);
    }

    roots[id].render(
      <Provider store={store}>
        <HelmetProvider>
          <BreadcrumbsProvider>
            <AppProvider>
              <Sportsbook />
            </AppProvider>
          </BreadcrumbsProvider>
        </HelmetProvider>
      </Provider>
    );
  });
}
